import { DirectPhoneCallGatewayStrategy } from 'components/phoneCall/phoneCallGateway/DirectPhoneCallGatewayStrategy';

import { AbstractDirectPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractDirectPhoneCallGatewayStrategy';

import { CommandBus } from 'src/util/command/CommandBus';
export class TelDirectPhoneCallGatewayStrategy
	extends AbstractDirectPhoneCallGatewayStrategy
	implements DirectPhoneCallGatewayStrategy
{
	constructor(commandBus: CommandBus, authenticatedUserId: number) {
		super(commandBus, authenticatedUserId);
	}

	public async makeCall(callerName: string, toNumber: string): Promise<null | string> {
		window.open(`tel:${toNumber}`);
		return await this.createPhoneCall(callerName, toNumber);
	}
}
